import { useListContext, RecordContextProvider } from 'react-admin';
import { Box, CircularProgress } from '@mui/material';
import { AdsCampaingsTile } from '@/components/adsCampaings/AdsCampaingsTile.jsx';
import { breakpoints } from '@/themes/themeOverrides/Breakpoints';

export const AdsCampaignsGrid = () => {
    const { data, isPending } = useListContext();

    if (isPending) {
        return (
            <Box display='flex' justifyContent='center' alignItems='center' minHeight={200}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
                gap: '24px',
                marginTop: '40px',
                [`@media (max-width: ${breakpoints.values.lg}px)`]: { gridTemplateColumns: 'repeat(1, 1fr)', marginTop: '20px' },
            }}
        >
            {data?.map(record => (
                <RecordContextProvider value={record} key={record.id}>
                    <AdsCampaingsTile />
                </RecordContextProvider>
            ))}
        </Box>
    );
};
